export function uploadedImage(newImageUrl) {
    if (newImageUrl) {
        if (typeof newImageUrl === 'object') {
            return URL.createObjectURL(newImageUrl)
        }
        return newImageUrl
    }
    return ''
}